export default "__VITE_ASSET__CBBFwUft__"